var map = {
	"./avengers.svg": "dc30",
	"./brotherhood.svg": "6fde",
	"./cabal.svg": "5f06",
	"./champions.svg": "caae",
	"./crime-syndicate.svg": "aa50",
	"./fantastic-four.svg": "da7b",
	"./foes-of-asgard.svg": "d8d5",
	"./guardians-of-the-galaxy.svg": "5d34",
	"./guardians-of-the-multiverse.svg": "ee67",
	"./heroes-of-asgard.svg": "9181",
	"./heroes-of-wakanda.svg": "7cec",
	"./hydra.svg": "5fa5",
	"./illuminati.svg": "758c",
	"./inhumans.svg": "3d49",
	"./marvel-knights.svg": "d7af",
	"./mercs-for-money.svg": "a893",
	"./new-warriors.svg": "e00a",
	"./shield.svg": "60b1",
	"./sinister-six.svg": "cfb5",
	"./spider-friends.svg": "e704",
	"./unaffiliated.svg": "2b2a",
	"./venomverse.svg": "025f",
	"./warbound.svg": "aaf4",
	"./x-factor-investigations.svg": "b94a",
	"./x-force.svg": "f59a",
	"./x-men.svg": "bce5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eee8";